'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { Box, Paper, Typography } from '@mui/material';

import { getEfacilUrl } from '~/shared/utils';

export function LobbyView() {
  const router = useRouter();
  const linkEfacil = getEfacilUrl();

  const handleRedirect = () => {
    router.push('/dashboard');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: '100vh',
        py: 6,
        px: 2,
      }}
    >
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Image
          src="/static/logo_martins_ads.svg"
          alt="Martins ADS"
          width={180}
          height={120}
          priority
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </Box>

      <Typography
        variant="h4"
        component="h1"
        sx={{ mb: 8, textAlign: 'center', fontWeight: 'normal' }}
      >
        Qual projeto você deseja acessar?
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 4,
          flexWrap: 'wrap',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '800px',
        }}
      >
        <Paper
          component={Box}
          onClick={handleRedirect}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '1.5rem',
            borderRadius: '4px',
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit',
            flexGrow: 1,
            maxWidth: '300px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
            transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
            '&:hover': {
              boxShadow:
                '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 3,
            }}
          >
            <Box
              sx={{
                bgcolor: '#f0f8ff',
                borderRadius: '4px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Image
                src="/static/logo_martins.png"
                alt="Martins"
                width={22}
                height={22}
              />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
              Martins ADS
            </Typography>
          </Box>
        </Paper>
        <Paper
          component={Link}
          href={linkEfacil}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '1.5rem',
            borderRadius: '4px',
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit',
            flexGrow: 1,
            maxWidth: '300px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
            transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
            '&:hover': {
              boxShadow:
                '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 3,
            }}
          >
            <Box
              sx={{
                bgcolor: '#f0f8ff',
                borderRadius: '4px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Image
                src="/static/logo_efacil.png"
                alt="Martins"
                width={22}
                height={22}
              />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
              Efacil ADS
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
